module.exports = __webpack_public_path__ + "static/media/CodePenLoginDialog.aa7210b9.PNG";